import React from "react";
import "../sass/main.scss";
import { Button, Card, Hidden, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  return (
    <div className="fluid-container background">
      <div className="main">
        <Card className="card">
          <div className="column-center p-2">
            <h4>Log in</h4>
            <label className="label">
              Save hours of finance work every week
            </label>
          </div>
          <div className="row">
            <div className="col-sm-12 p-2">
              <label>Email</label>
              <TextField
                id="standard-full-width"
                placeholder="Email"
                variant="standard"
                InputProps={{ disableUnderline: true }}
                InputLabelProps={{
                  disableAnimation: false,
                }}
                className="width-textfield background-textfield"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 p-2">
              <label>Password</label>
              <TextField
                id="standard-full-width"
                placeholder="Password"
                variant="standard"
                type="password"
                InputProps={{ disableUnderline: true }}
                InputLabelProps={{
                  disableAnimation: false,
                }}
                className="width-textfield background-textfield"
              />
            </div>
          </div>
          <div className="row">
            <label className="label">
              Forgot your password?{" "}
              <span className="text-underline">Recover now</span>
            </label>
          </div>

          <div className="row">
            <div className="col-sm-12 p-2">
              <Button
                className="btn-main width-textfield"
                onClick={() => navigate("/verification")}
              >
                Continue
              </Button>
            </div>
          </div>
          <div className="column-center p-2">
            <label className="label">
              Don't have an account?{" "}
              <span
                className="text-underline"
                onClick={() => navigate("/signup")}
              >
                Sign Up
              </span>
            </label>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Login;
